import React, { useEffect, useMemo, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';

import { Link } from 'react-router-dom';
import { Input, Button, InputGroup, Media, FormGroup, Form, Label } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { redirect } from '../actions';
import { checkRegisteredUser, resetUser } from '../actions/OktaActions';
import SquareLogo from './assets/squareLogo.jpg';
import {
  RegisterContainer,
  ImageContainer,
  MainContainerRow,
  MainContainerCol,
  RegisterContainerHeader,
  RegisterContainerBody,
  SkyanName,
  TermsLink,
} from './Login/style';

const PreLogin = (props) => {
  const { authState } = useOktaAuth();
  const [email, setEmail] = useState(props.previousEmail);

  useEffect(() => {
    const user = {
      email,
    };
    if (props.emailAlreadyRegistered) {
      return props.redirect('/login');
    }
    if (props.emailNoClientFound) {
      props.resetUser(user);
      return props.redirect('/register');
    }
  }, [props.emailAlreadyRegistered, props.emailNoClientFound]);

  const validateEmail = useMemo(() => {
    const validEmailPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (validEmailPattern.test(email) && email?.length > 5) {
      return false;
    }
    return true;
  }, [email]);

  const handleFoward = () => {
    const user = {
      email,
    };
    props.checkRegisteredUser(user);
  };
  const isInIframe = () => window.self !== window.top;

  if (authState?.isAuthenticated || isInIframe()) {
    return props.redirect('/home');
  }
  return (
    <>
      <ImageContainer />
      <MainContainerRow>
        <MainContainerCol>
          <SkyanName>SKYAN</SkyanName>
          <RegisterContainer>
            <RegisterContainerHeader>
              <Media right object height="40px" src={SquareLogo} alt="NEPC Logo Square" />
            </RegisterContainerHeader>
            <RegisterContainerBody>
              <Form
                onSubmit={(event) => {
                  event.preventDefault();
                  handleFoward();
                }}
              >
                <FormGroup>
                  <Label for="email-input">Please input your Email</Label>
                  <InputGroup id="email-input">
                    <Input
                      name="email"
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      value={email}
                      onSubmit={handleFoward}
                      type="email"
                      autoFocus
                    />
                    <Button color="primary" onClick={handleFoward} disabled={validateEmail}>
                      <i className="pi pi-arrow-right" style={{ fontSize: '0.75rem' }}></i>
                    </Button>
                  </InputGroup>
                </FormGroup>
                <div className="advice-text">
                  Don’t want to see this page again? Bookmark your <Link to="/home">{' home '}</Link> page and you will
                  automatically be redirected to your login.
                </div>
              </Form>
            </RegisterContainerBody>
          </RegisterContainer>
          <TermsLink>
            <a href="/terms" className="nav-link">
              Terms and Conditions
            </a>
          </TermsLink>
        </MainContainerCol>
      </MainContainerRow>
    </>
  );
};

PreLogin.propTypes = {
  checkRegisteredUser: PropTypes.func.isRequired,
  previousEmail: PropTypes.string.isRequired,
  redirect: PropTypes.func.isRequired,
  // Status
  emailNoClientFound: PropTypes.bool.isRequired,
  emailAlreadyRegistered: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string,
  resetUser: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { okta } = state;
  return {
    previousEmail: okta.registering.user.email || '',
    emailNoClientFound: okta.registering.emailNoClientFound,
    emailAlreadyRegistered: okta.registering.emailAlreadyRegistered,
    success: okta.registering.success,
    error: okta.registering.error,
    loading: state.ui.isLoading,
    redirectTo: state.ui.redirect,
  };
};

export default connect(mapStateToProps, { checkRegisteredUser, redirect, resetUser })(PreLogin);
